import { render, staticRenderFns } from "./ProfilCompanyInfo.vue?vue&type=template&id=61fc5889&"
import script from "./ProfilCompanyInfo.vue?vue&type=script&lang=js&"
export * from "./ProfilCompanyInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports